import TextInput, { TextInputProps } from './TextInput'

export default TextInput

export { TextInput, TextInputProps }
